module.exports = __webpack_public_path__ + "static/media/mountains.22ec1608.jpg";